import * as T from '../types'

function discKey (discId: number | string): string {
  return `disc_id_${discId}`
}

export function processCustomerDiscData (fields: T.DDPayload[], customerData: T.CustomerDiscData[]): {
    [key: string]: string | string[]
} {
  /*
    A customer's saved disc data may be invalid if the merchant settings were later changed
    - If it's a text disc data type, we can populate the invalid value in the form input
      and user will get validation feedback to update
    - If it's a dropdown or multi-select, discard any invalid values
  */
  const processedSingleValues: { [key: string]: string } = {}
  const processedMultiValues: { [key: string]: string[] } = {}
  const allowedValues: { [key: string]: string[] } = {}

  fields.forEach((field: T.DDPayload) => {
    const key = discKey(field.disc_id)
    if (field.type === 'M') {
      processedMultiValues[key] = []
      allowedValues[key] = field.disc_values.map(disc_value => disc_value.value)
    } else if (field.type === 'D') {
      processedSingleValues[key] = ''
      allowedValues[key] = field.disc_values.map(disc_value => disc_value.value)
    } else {
      processedSingleValues[key] = ''
    }
  })

  customerData.forEach((data: T.CustomerDiscData) => {
    const key = discKey(data.disc_id)
    // invalid multi-select or dropdown
    if (key in allowedValues && !(allowedValues[key].includes(data.value))) {
      return
    }

    if (key in processedSingleValues) {
      processedSingleValues[key] = data.value
      return
    }

    if (key in processedMultiValues) {
      processedMultiValues[key] = [...processedMultiValues[key], data.value]
    }
  })

  return { ...processedSingleValues, ...processedMultiValues }
}

export function transactionSearchDDToCustomerDD (tDD: T.TransactionSearchDD[]): T.CustomerDiscData[] {
  const response: T.CustomerDiscData[] = []
  tDD.forEach(disc => {
    disc.disc_values.forEach(val => {
      if (val) {
        response.push({ disc_id: disc.disc_id, value: val })
      }
    })
  })
  return response
}
